export const Capitalize = (text: string) => {
  if (text && text.length > 0) {
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  } else {
    return '';
  }
};
